module.exports = __webpack_public_path__ + "img/sh.75cc7156.svg";